import ibm from './ibm.svg?inline'
import iconCorrect from './icons/correct.svg?inline'
import iconIncorrectWarning from './icons/incorrect-warning.svg?inline'
import iconIncorrectDanger from './icons/incorrect-danger.svg?inline'
import iconEmergencyExit from './icons/emergency-exit.svg?inline'
import iconHeadphones from './icons/headphones.svg?inline'
import iconCross from './icons/cross.svg?inline'
import iconArrowRight from './icons/arrow-right.svg?inline'

export const ASSETS = {
  ibm,
  iconCorrect,
  iconIncorrectWarning,
  iconIncorrectDanger,
  iconEmergencyExit,
  iconHeadphones,
  iconCross,
  iconArrowRight,
} as const
